// extracted by mini-css-extract-plugin
export default {"sideMenu":"sideMenu_sideMenu__tcXTu"};